/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  ModelTreeNode,
  ParsedTreeNodeType,
} from '../../modelConfiguration/data/modelOptionsTree';

import {
  ModelConfigurationLinearNode,
} from './modelConfigurationLinearNode';

import { TreeSelections } from '../../modelConfiguration/data/treeSelection';
import { ModelConfigurationLinearGroupContainer } from './modelConfigurationLinearGroupContainer';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';

interface ModelConfigurationLinearNodeRootProps {
  node : ModelTreeNode,
  treeSelectionState: TreeSelections,
  tagsTranslation : CatalogTagsTranslation[],
  languageSelected : string,
  updateTreeSelectionState: (selection: TreeSelections) => void,
  updateOptionSelection: (groupID : number, optionID : number) => void,
  getResourcePath: (path: string) => string,
}

export function ModelConfigurationLinearRoot(
  {
    node,
    treeSelectionState,
    tagsTranslation,
    languageSelected,
    updateTreeSelectionState,
    updateOptionSelection,
    getResourcePath,
  } : ModelConfigurationLinearNodeRootProps,
) : JSX.Element {

  // Since this is a root, I won't have any representation myself.
  // Depending in each children, I'll show them and create an appropriate
  // container for their contents

  const renderChildren = (child : ModelTreeNode) : JSX.Element => {

    let childContainer : JSX.Element;

    if (child.type === ParsedTreeNodeType.Group
      || child.type === ParsedTreeNodeType.Domain) {

      childContainer = (
        <ModelConfigurationLinearGroupContainer
          node={child}
          treeSelectionState={treeSelectionState}
          tagsTranslation={tagsTranslation}
          languageSelected={languageSelected}
          updateTreeSelectionState={updateTreeSelectionState}
          updateOptionSelection={updateOptionSelection}
          getResourcePath={getResourcePath}
        />
      );
    } else {
      childContainer = (
        <div>
          No container defined for type
          {' '}
          {child.type}
        </div>
      );
    }

    return (
      <React.Fragment
        key={child.name}
      >
        <ModelConfigurationLinearNode
          node={child}
          pathParent={node.path}
          pathNode={child.name}
          treeSelectionState={treeSelectionState}
          updateTreeSelectionState={updateTreeSelectionState}
          updateOptionSelection={updateOptionSelection}
          getResourcePath={getResourcePath}
          languageSelected={languageSelected}
        />
        {childContainer}
      </React.Fragment>
    );
  };

  return (
    <>
      { renderChildren(node) }
    </>
  );
}
